import { Box, Card, CardContent, Grid, Skeleton, Divider } from "@mui/joy";

export function EstimatingSkeleton() {
    return (
        <Box>
            {/* Header Section */}
            <Box mb={2.5}>
                <Skeleton variant="text" width={220} height={28} />
                <Skeleton variant="text" width={380} height={20} sx={{ mt: 0.5 }} />
            </Box>

            <Grid container spacing={2}>
                {/* Column 1: Site Setup & Structure */}
                <Grid xs={12} md={7}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {/* Site Setup Card */}
                        <Card variant="soft">
                            <CardContent>
                                <Skeleton variant="text" width={180} height={24} sx={{ mb: 2 }} />
                                <Grid container spacing={1.5} mb={2}>
                                    <Grid xs={6}>
                                        <Skeleton variant="text" width={80} height={16} sx={{ mb: 1 }} />
                                        <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: "sm" }} />
                                    </Grid>
                                    <Grid xs={6}>
                                        <Skeleton variant="text" width={80} height={16} sx={{ mb: 1 }} />
                                        <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: "sm" }} />
                                    </Grid>
                                </Grid>
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Skeleton variant="text" width={140} height={20} />
                                    <Skeleton variant="text" width={40} height={20} />
                                </Box>
                                <Skeleton variant="rectangular" width="100%" height={8} sx={{ borderRadius: "lg", mb: 1 }} />
                            </CardContent>
                        </Card>

                        {/* Complexity Adjustments Card */}
                        <Card variant="soft">
                            <CardContent>
                                <Skeleton variant="text" width={160} height={24} sx={{ mb: 2 }} />
                                <Box sx={{ p: 1.5, border: "1px solid", borderColor: "divider", borderRadius: "md" }}>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Skeleton variant="rectangular" width={18} height={18} sx={{ borderRadius: "sm" }} />
                                        <Skeleton variant="text" width={150} height={20} />
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                </Grid>

                {/* Column 2: Financials & Logistics */}
                <Grid xs={12} md={5}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {/* Payment Card */}
                        <Card variant="soft">
                            <CardContent>
                                <Skeleton variant="text" width={180} height={24} sx={{ mb: 2 }} />
                                <Skeleton variant="text" width={120} height={16} sx={{ mb: 1 }} />
                                <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: "sm" }} />
                            </CardContent>
                        </Card>

                        {/* Logistics Card */}
                        <Card variant="soft">
                            <CardContent>
                                <Skeleton variant="text" width={140} height={24} sx={{ mb: 2 }} />
                                <Box display="flex" flexDirection="column" gap={1.5}>
                                    {[1, 2, 3].map(i => (
                                        <Box key={i} display="flex" justifyContent="space-between" alignItems="center">
                                            <Skeleton variant="text" width={100} height={18} />
                                            <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: "sm" }} />
                                        </Box>
                                    ))}
                                </Box>
                                <Divider sx={{ my: 1.5 }} />
                                <Box display="flex" flexDirection="column" gap={1.5}>
                                    {[1, 2].map(i => (
                                        <Box key={i} display="flex" justifyContent="space-between" alignItems="center">
                                            <Skeleton variant="text" width={100} height={18} />
                                            <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: "sm" }} />
                                        </Box>
                                    ))}
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
